import {takeEvery, all, call} from 'redux-saga/effects';
import {deliveryMetadata} from './workers';
import {deliveryContentItemViewMetadataUpdatesAction} from '../ContentItemViewMetadataActions';

function* watchDeliveryMetadataWorker() {
    yield takeEvery(deliveryContentItemViewMetadataUpdatesAction, deliveryMetadata);
}

export function* watchContentItemViewMetadata() {
    yield all([
        call(watchDeliveryMetadataWorker),
    ]);
}
